<template>
  <button
    class="btn"
    :class="style"
    @click="handleClick()"
    :disabled="loading || disabled"
  >
    <span v-if="!loading">{{ text }}</span>
    <span class="loading-btn" v-if="loading"
      ><span>&bull;</span><span>&bull;</span><span>&bull;</span></span
    >
  </button>
</template>

<script>
export default {
  props: ["classes", "loading", "text", "disabled"],
  data() {
    return {
      style: [],
    };
  },
  methods: {
    parseClasses() {
      if (this.classes) {
        this.style = this.classes.join(" ");
      }
    },
    handleClick() {
      this.$emit("click", true);
    },
  },
  mounted() {
    this.parseClasses();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/LoadingButton.vue